<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { ref } from 'vue';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();

    const scrollContainerRef = ref<HTMLDivElement | null>(null);
    const getScrollElement = () => scrollContainerRef.value;

    defineExpose({ getScrollElement });
</script>

<template>
    <div
        data-slot="table-container"
        class="relative h-full w-full overflow-auto"
        ref="scrollContainerRef"
    >
        <table
            data-slot="table"
            :class="cn('w-full caption-bottom text-sm', props.class)"
        >
            <slot />
        </table>
    </div>
</template>
